import { httpClient } from "./httpClient";

export const getSSBSubject = () => httpClient.get(`/ssb/subject`);

export const getSSBCountryList = () => httpClient.get(`/ssb/country`);
